/* ==========================================================================
   PDP Sections — kleine interacties voor de content-secties (FAQ-toggle).
   Document-brede delegatie, veilig meerdere keren te laden.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__pdpSectionsInit) return;
  window.__pdpSectionsInit = true;

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.pdp-faq__head');
    if (!head) return;
    var item = head.closest('.pdp-faq__item');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    var sym = head.querySelector('.pdp-faq__sym');
    if (sym) sym.textContent = open ? '–' : '+';

    // Exclusief (één tegelijk open) — alleen in lijsten met data-pdp-single.
    if (open) {
      var single = item.closest('[data-pdp-single]');
      if (single) {
        single.querySelectorAll('.pdp-faq__item.is-open').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          var oh = other.querySelector('.pdp-faq__head');
          if (oh) oh.setAttribute('aria-expanded', 'false');
          var os = other.querySelector('.pdp-faq__sym');
          if (os) os.textContent = '+';
        });
      }
    }
  });
})();
